// phone_code_country_rule_30sep2026 — CEO ruling: the phone dialling code
// sets country, region, currency and price list. +234 -> Nigeria/NGN,
// +44 -> United Kingdom/GBP. Other dialling codes are untouched.
export const PHONE_COUNTRY_RULES = {
  '+234': { code: '+234', country: 'Nigeria', region: 'nigeria', currency: 'NGN', priceList: 'nigeria', regionLabel: 'Nigeria' },
  '+44': { code: '+44', country: 'United Kingdom', region: 'uk', currency: 'GBP', priceList: 'uk', regionLabel: 'United Kingdom' },
};

export const phoneRule = (phone) => {
  let p = String(phone || '').replace(/[\s()\-.]/g, '');
  if (p.startsWith('00')) p = `+${p.slice(2)}`;
  if (!p.startsWith('+')) return null;
  return Object.values(PHONE_COUNTRY_RULES).find(r => p.startsWith(r.code)) || null;
};
